import { NavLink } from "react-router-dom";
import { isSwitchedFromSuperAdminSession } from "../../../../utils/auth";
import { AdminMenus } from "./admin";
import { UserMenus } from "./user";

const SYSTEM_LOGS_MENU_ITEM = {
  label: "System Logs",
  key: "system-logs",
  icon: "ki-outline ki-notepad-bookmark",
};

const filterUserMenus = (menus, user) => {
  const parentUserId = user?.user?.user_data?.parent_user_id;
  
  // Hide menu if parent_user_id has ANY value (including 0, 1, 2, 3, etc.)
  // Show menu only when parent_user_id is null
  if (parentUserId !== null) {
    return menus.map(menu => ({
      ...menu,
      children: menu.children?.filter(child => child.key !== "settings/manage-seller")
    }));
  }
  
  return menus;
};

export const FindMenus = (type, user) => {
  
  let menus;
  if (type === "user") {
    menus = filterUserMenus(UserMenus, user);
    if (isSwitchedFromSuperAdminSession(user)) {
      menus = [...menus, SYSTEM_LOGS_MENU_ITEM];
    }
  } else if (type === "admin") {
    menus = AdminMenus;
  } else if (type === "superAdmin") {
    menus = AdminMenus;
  } else {
    menus = [];
  }

  return menus?.map((d, i) => {
    if (d?.children) {
      return {
        ...d,
        icon: <i className={`${d.icon} fs-1`} />,
        label: d.label,
        children: d?.children?.map((child) => ({
          ...child,
          icon: child.icon ? <i className={`${child.icon} fs-3`} /> : null,
          label: <NavLink to={child.key}>{child.label}</NavLink>,
        })),
      };
    }

    return {
      ...d,
      icon: <i className={`${d.icon} fs-1`} />,
      label: <NavLink to={d.key}>{d.label}</NavLink>,
    };
  });
};